import "@fontsource/poppins";
import { useEffect, useState } from "react";
import { ThemeProvider } from "@material-ui/core/styles";
import theme, { GlobalCss } from "./styles/theme";
import Playground from './pages/Playground';
import { initialState, StateContext } from "src/store/state";
import { QueryClient, QueryClientProvider } from "react-query";
import mixpanel from 'mixpanel-browser';

function App() {
  const [queryClient] = useState(() => new QueryClient());

  useEffect(() => {
    mixpanel.init('4ffaebe48702578119d812ed701caed8');

    if (window.navigator.userAgent.toLowerCase().includes('firefox')) {
      mixpanel.opt_in_tracking()
    }

    if (window.location.href.includes('localhost')) {
      mixpanel.opt_out_tracking()
    }
  }, [])


  return (
    <div>
      <QueryClientProvider client={queryClient}>
        <StateContext.Provider value={initialState}>
          <ThemeProvider theme={theme}>
              <GlobalCss />
              <Playground></Playground>
          </ThemeProvider>
        </StateContext.Provider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
